module.exports = __webpack_public_path__ + "static/media/facebook.a6a36fca.svg";